<template>
  <div>
    <div
      class="mt-4"
      style="display:flex; justify-content:space-between;"
      :style="info ? 'background-color: white' : 'background-color: black' "
    >
      <div>
        <v-btn
          class="ma-2"
          :outlined="!edit"
          color="red"
          @click="edit=!edit"
        >
          Upravit
        </v-btn>
      </div>
      <div>
        <v-btn
          class="ma-2"
          :outlined="info"
          :color="main ? 'white' : 'black'"
          @click="main = true; info = false; gallery = false"
        >
          Main
        </v-btn>
        <v-btn
          class="ma-2"

          :color="main ? 'white' : 'black white--text'"
          :outlined="main"
          @click="main = false; info = true; gallery = false"
        >
          Info
        </v-btn>
        <v-btn
          class="ma-2"

          :color="main ? 'white' : 'black white--text'"
          :outlined="main"
          @click="main = false; info = false; gallery = true"
        >
          Galerie
        </v-btn>
      </div>
    </div>
    <static-gallery-view v-if="gallery && !edit" />
    <static-home-view v-else-if="main && !edit" />
    <static-about-view v-else-if="info && !edit" />
    <edit-gallery-view v-else-if="gallery && edit" />
    <edit-home-view v-else-if="main && edit" />
    <edit-about-view v-else-if="info && edit" />
  </div>
</template>

<script>
import StaticGalleryView from '../../components/editPages/StaticGalleryView.vue'
import EditGalleryView from '../../components/editPages/EditGalleryView.vue'
import EditHomeView from '../../components/editPages/EditHomeView.vue'
import EditAboutView from '../../components/editPages/EditAboutView.vue'
import StaticHomeView from '../../components/editPages/StaticHomeView.vue'
import StaticAboutView from '../../components/editPages/StaticAboutView.vue'
export default {
  components: {
    EditGalleryView,
    StaticGalleryView,
    EditHomeView,
    EditAboutView,
    StaticHomeView,
    StaticAboutView
  },
  data () {
    return {
      main: true,
      info: false,
      edit: false,
      gallery: false
    }
  }
}
</script>